const BinIcon = ({
  style = { height: "1.25vh", width: "1.25vh" },
  color = "grey",
}) => {
  return (
    <svg viewBox="0 0 36 48" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icon">
          <path
            d="m2 6h32a2 2 0 0 1 2 2v2a0 0 0 0 1 0 0h-36a0 0 0 0 1 0 0v-2a2 2 0 0 1 2-2z"
            fill={color && color}
          />
          <path
            d="m14 0h8a2 2 0 0 1 2 2v2a0 0 0 0 1 0 0h-12a0 0 0 0 1 0 0v-2a2 2 0 0 1 2-2z"
            fill={color && color}
          />
          <path
            d="m4 12 1.9 34.11a2 2 0 0 0 2 1.89h20.21a2 2 0 0 0 2-1.89l1.89-34.11zm9 29a2 2 0 0 1 -4 0v-22a2 2 0 0 1 4 0zm7 0a2 2 0 0 1 -4 0v-22a2 2 0 0 1 4 0zm7 0a2 2 0 0 1 -4 0v-22a2 2 0 0 1 4 0z"
            fill={color && color}
          />
        </g>
      </g>
    </svg>
  );
};

export default BinIcon;
